import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import Hidden from '@material-ui/core/Hidden';
import {getContactFromConversation} from '../../../../../utils/ComponentUtilFunctions';
import config from '../../../../../config';
import Arrow from '../../../../../components/Arrow';
import Forward from "../../../../../assets/images/forward.png";
import ForwardDialog from './ForwardDialog';
import {getConversationInfo, getUserByEmails} from "../../../../../services/company/api";
import Translate from "../../../../../components/Translate";
import Volume from "../../../../../assets/images/volume.png"
import VolumeMute from "../../../../../assets/images/volume-mute.png"
import SearchIcon from "../../../../../assets/images/search.png"
import BlockUsers from "../../../../../assets/images/block-user.png";
import InfoIcon from "../../../../../assets/images/info-white.png";
import Ticket from "../../../../../assets/images/wirte.png";
import EndConversation from "../../../../../assets/images/end-conversation.png";
import Files from "../../../../../assets/images/file-search.png";
import useHotkeyActions from "../../../../../utils/useHotkeyAction";
import Tooltip from "../../../../../components-new/Tooltip";
import ChatMoreInfoModal from "../../../../../components/ChatMoreInfoModal";
import ProfileImageViewer from "../../../../../components/ProfileImageViewer";

export const styles = {
    userInfoText: {
        fontSize: '13px',
        color: '#d0d0d0',
        margin: 0,
    },

    extraInfoBox: {
        padding: '10px',
        borderRadius: '8px',
        maxWidth: '259px',
        display: 'flex',
        flexDirection: 'column',
        gap: '2px',
        color: 'white',
        backgroundColor: 'rgba(255,255,255,0.05)',
    },

    ellipsisText: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontSize: '10px',
        color: '#cfcfcf',
        margin: 0,
    },
};


const headerStyles = {
    header: {
        display: 'flex',
        flexDirection: 'row',
        padding: '10px 15px',
        height: '75px',
        backgroundColor: 'rgb(4, 62, 92)',
        borderRadius: '10px',
        alignItems: 'center'
    },
    button: {
        padding: '0 15px',
        background: 'transparent',
        color: '#A4ADC1',
        height: '100%',
        fontSize: '12px',
        fontWeight: 100,
        cursor: 'pointer',
    },
    userNameText: {
        lineHeight: '16px',
        fontSize: '13px',
        color: 'white',
        fontWeight: 600,
        marginBottom: '5px',
        maxWidth: '300px',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
    },
    userInfoText: {
        lineHeight: '12px',
        fontSize: '11px',
        color: 'white',
        fontWeight: 400,
        marginBottom: '2px'
    },
    platformText: {
        lineHeight: '16px',
        fontSize: '12px',
        color: 'white',
    },
    noPadding: {
        padding: '0 !important',
    }
};

const ellipsisStyle = {
    ...headerStyles.platformText,
    color: 'white',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
};

const ConversationHeader = (props) => {
    const {
        conversation, endConversation, openContactList, readOnly, hasBackButton, ticketClick, blockUserClick,
        filteredMembers, forwardConversation, user, tariff, company, toggleSearchDiv, toggleMediaViewDiv, hotkeys,
        showConversationHistory
    } = props;

    const [isSoundEnabled, setIsSoundEnabled] = useState(true);
    const [dialogState, setDialogState] = useState({isOpen: false, mode: ''});
    const [companyName, setCompanyName] = useState([company && company.subs ? company.subs.filter(c => c.id == conversation.companyId)[0] ? company.subs.filter(c => c.id == conversation.companyId)[0].name : "" : company.name]);
    const [conversationInfo, setConversationInfo] = useState();
    const features = tariff ? tariff.features : [];

    const [members, setMembers] = useState([]);
    const [isInnerModalOpen, setIsInnerModalOpen] = useState(false);
    const [isProfileViewerOpen, setIsProfileViewerOpen] = useState(false);

    useEffect(() => {
        if (conversation.id) {
            getConversationInfo(conversation.id)
                .then(data => {
                    setConversationInfo(data);
                });
        }

        if (conversation.id) {
            const stored = sessionStorage.getItem(`soundEnabled-${conversation.id}`);
            setIsSoundEnabled(stored !== 'false');
        }

    }, [conversation.id]);

    const contact = getContactFromConversation(conversation);
    const firstName = contact.firstName ? contact.firstName : '';
    const lastName = contact.lastName ? contact.lastName : '';
    const thumbUrl = contact.thumbUrl ? contact.thumbUrl : null;

    const openDialog = (mode) => {
        setDialogState({isOpen: true, mode});
    };

    const closeDialog = () => {
        setDialogState({isOpen: false, mode: ''});
    };

    const toggleSound = () => {
        const newValue = !isSoundEnabled;
        sessionStorage.setItem(`soundEnabled-${conversation.id}`, newValue);
        setIsSoundEnabled(newValue);
    };

    const handleForwardClick = () => {
        getUserByEmails(filteredMembers.map(m => m.email)).then(data => {
            const updatedData = data.map(user => ({
                ...user,
                id: user.platformId
            }));
            const sortedData = updatedData.sort((a, b) => a.currentStatus.localeCompare(b.currentStatus));
            setMembers(sortedData);
        });

        openDialog('forward');
    };

    if (!readOnly && contact.platform !== config.platforms.company) {
        const actionHandlers = {
            OPEN_FORWARD_DIALOG: () => handleForwardClick(),
            OPEN_BLOCK_USER_MODAL: () => blockUserClick(),
            OPEN_END_CHAT_MODAL: () => endConversation(),
            OPEN_SAVE_INFO_MODAL: () => ticketClick(),
            OPEN_SEARCH_MODAL: () => toggleSearchDiv(),
            OPEN_FILES_MODAL: () => toggleMediaViewDiv(),
            OPEN_INFO_MODAL: () => openInfoModal(),
        };
        useHotkeyActions(hotkeys, actionHandlers);
    }

    const openInfoModal = () => {
        setIsInnerModalOpen(true);
    }

    const closeInfoModal = () => {
        setIsInnerModalOpen(false);
    }

    return (
        <div style={headerStyles.header}>
            {hasBackButton && (
                <Hidden mdUp>
                    <button
                        type="button"
                        style={{
                            textAlign: 'center',
                            width: '35px',
                            height: '35px',
                            border: 'none',
                            backgroundColor: 'rgb(4, 62, 92)',
                            cursor: 'pointer',
                            color: 'white'
                        }}
                        onClick={openContactList}
                    >
                        <Arrow fill="white"/>
                    </button>
                </Hidden>
            )}
            <div className="contact-info"
                 style={{
                     marginLeft: '20px',
                     display: 'flex',
                     justifyContent: 'center',
                     alignItems: 'center',
                     gap: '22px'
                 }}>

                <div>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                    }}>
                        <div>
                            {thumbUrl && (
                                <img
                                    src={thumbUrl}
                                    width={35}
                                    height={35}
                                    style={{
                                        borderRadius: '50%',
                                        objectFit: 'cover',
                                        border: '1px solid #ccc',
                                        boxShadow: '0 0 2px rgba(0,0,0,0.15)',
                                        marginRight: '5px',
                                        cursor: 'pointer',
                                    }}
                                    onClick={() => setIsProfileViewerOpen(true)}
                                />
                            )}

                            {isProfileViewerOpen && (
                                <ProfileImageViewer
                                    imageUrl={thumbUrl}
                                    close={() => setIsProfileViewerOpen(false)}
                                />
                            )}
                        </div>


                        <p style={headerStyles.userNameText}>
                            {`${firstName} ${lastName}`}
                        </p>
                    </div>


                    {conversation.platform !== config.platformsMap.company && (
                        <React.Fragment>
                            <p style={headerStyles.userInfoText}>{contact.visitorEmail}</p>
                            <p style={headerStyles.userInfoText}>{contact.visitorPhoneNumber}</p>
                        </React.Fragment>
                    )}

                </div>

                {conversation.platform !== config.platformsMap.company && (
                    <div style={styles.extraInfoBox}>
                        {conversation.platform !== config.platformsMap.company && contact.platform && (
                            <p style={styles.ellipsisText}>🌍 <Translate text={'platform'}/>: {contact.platform}</p>
                        )}
                        {conversation.platform !== config.platformsMap.company && companyName && (
                            <p style={styles.ellipsisText}>🏢 <Translate text={'bot'}/>: {companyName}</p>
                        )}
                        {conversation.lastChoseSkillName && (
                            <p style={styles.ellipsisText}>🏷️ <Translate
                                text={'chosenSkill'}/>: {conversation.lastChoseSkillName}</p>
                        )}
                        {conversation.lastOperatorName && conversation.lastOperatorName !== " " && (
                            <p style={styles.ellipsisText}>🎧 <Translate
                                text={'operator'}/>: {conversation.lastOperatorName}
                            </p>
                        )}
                    </div>
                )}


            </div>

            <div className="flex-spacer"/>

            <Tooltip text={"info"}>
                <button
                    type="button"
                    id="block-user-conversation-button"
                    key="block-user-conversation-button"
                    className="no-style-button centered-flex-container"
                    style={{
                        ...headerStyles.button,
                        padding: '0 10px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: 'none',
                        background: 'transparent',
                    }}
                    onClick={openInfoModal}
                >
                    <img style={{width: '23px'}} src={InfoIcon}/>
                </button>
            </Tooltip>

            <Tooltip text={"files"}>
                <button
                    type="button"
                    onClick={toggleMediaViewDiv}
                    style={{
                        ...headerStyles.button,
                        padding: '0 10px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: 'none',
                        background: 'transparent',
                    }}
                >
                    <img
                        src={Files}
                        style={{width: '20px', height: '20px'}}
                    />
                </button>
            </Tooltip>

            <Tooltip text={"search"}>
                <button
                    type="button"
                    onClick={toggleSearchDiv}
                    style={{
                        ...headerStyles.button,
                        padding: '0 10px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: 'none',
                        background: 'transparent',
                    }}
                >
                    <img
                        src={SearchIcon}
                        style={{width: '20px', height: '20px'}}
                    />
                </button>
            </Tooltip>

            {!readOnly && contact.platform !== config.platforms.company && (
                <div className="centered-flex-container">

                    <Tooltip text={"enable/disable"}>
                        <button
                            type="button"
                            onClick={toggleSound}
                            style={{
                                ...headerStyles.button,
                                padding: '0 10px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                border: 'none',
                                background: 'transparent',
                            }}
                        >
                            <img
                                src={isSoundEnabled ? Volume : VolumeMute}
                                alt={isSoundEnabled ? "Sound on" : "Sound off"}
                                style={{width: '20px', height: '20px'}}
                            />
                        </button>
                    </Tooltip>

                    {features.includes(config.features.CONVERSATION_FORWARD) && (
                        <Tooltip text={"forward"}>
                            <button
                                type="button"
                                id="open-forward-list-button"
                                key="open-forward-list-button"
                                className="no-style-button centered-flex-container"
                                style={{
                                    ...headerStyles.button,
                                    padding: '0 10px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    border: 'none',
                                    background: 'transparent',
                                }}
                                onClick={() => {
                                    handleForwardClick()
                                }}
                            >
                                <img style={{width: '23px'}} src={Forward}/>
                            </button>
                        </Tooltip>
                    )}

                    {features.includes(config.features.BLACK_LIST) && (
                        <Tooltip text={"blockUser"}>
                            <button
                                type="button"
                                id="block-user-conversation-button"
                                key="block-user-conversation-button"
                                className="no-style-button centered-flex-container"
                                style={{
                                    ...headerStyles.button,
                                    padding: '0 10px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    border: 'none',
                                    background: 'transparent',
                                }}
                                onClick={blockUserClick}
                            >
                                <img style={{width: '23px'}} src={BlockUsers}/>
                            </button>
                        </Tooltip>
                    )}

                    <Tooltip text={"notes"}>
                        <button
                            type="button"
                            id="ticket-conversation-button"
                            key="ticket-conversation-button"
                            className="no-style-button centered-flex-container"
                            style={{
                                ...headerStyles.button,
                                padding: '0 10px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                border: 'none',
                                background: 'transparent',
                            }}
                            onClick={ticketClick}
                        >
                            <img style={{width: '23px'}} src={Ticket} alt="Ticket Icon"/>
                            {conversationInfo && (
                                <div
                                    style={{
                                        position: 'absolute',
                                        top: '-2px',
                                        right: '11px',
                                        width: '10px',
                                        height: '10px',
                                        backgroundColor: 'red',
                                        borderRadius: '50%',
                                    }}
                                />
                            )}
                        </button>
                    </Tooltip>

                    <Tooltip text={"endConversation"}>
                        <button
                            type="button"
                            id="end-conversation-button"
                            key="end-conversation-button"
                            className="no-style-button centered-flex-container"
                            style={{
                                ...headerStyles.button,
                                padding: '0 10px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                border: 'none',
                                background: 'transparent',
                            }}
                            onClick={endConversation}
                        >
                            <img style={{width: '23px'}} src={EndConversation}/>
                        </button>
                    </Tooltip>

                </div>
            )}

            <ForwardDialog
                state={dialogState}
                close={closeDialog}
                contactList={members}
                contactClick={forwardConversation}
                dialogMode={dialogState.mode}
                user={user}
                conversation={conversation}
            />

            <ChatMoreInfoModal
                isOpen={isInnerModalOpen}
                onRequestClose={closeInfoModal}
                company={company}
                showConversationHistory={showConversationHistory}
                conversation={conversation}
            />

        </div>
    );
};

ConversationHeader.propTypes = {
    conversation: PropTypes.object.isRequired,
    endConversation: PropTypes.func,
    openContactList: PropTypes.func.isRequired,
    readOnly: PropTypes.bool,
    hasBackButton: PropTypes.bool,
};

ConversationHeader.defaultProps = {
    readOnly: false,
    hasBackButton: true,
};

export default ConversationHeader;




// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/chat/chat-components/ConversationHeader.jsx